import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import * as API from '../apiConfig';
import {
    OrderShareSuccessModal,
    ShareOnWhatsAppIconButton,
    shareOrderOnWhatsApp,
} from "./OrderShareWhatsApp";

function Orders() {
    const initialOrderForm = {
        description: '',
        height: '',
        width: '',
        quantity: 1,
        rate: '',
        clientId: '',
        file: '',
    };
    const { authData, onLogout } = useOutletContext();
    const navigate = useNavigate();
    const authToken = authData?.token;
    const [isClientModalOpen, setIsClientModalOpen] = useState(false);
    const [isOrdersModalOpen, setIsOrdersModalOpen] = useState(false);
    const [isBillsModalOpen, setIsBillsModalOpen] = useState(false);
    const [clients, setClients] = useState([]);
    const [orders, setOrders] = useState([]);
    const [bills, setBills] = useState([]);
    const [selectedBill, setSelectedBill] = useState(null);
    const [selectedClientIdForBill, setSelectedClientIdForBill] = useState('');
    const [selectedOrderIds, setSelectedOrderIds] = useState([]);
    const [billClientSearch, setBillClientSearch] = useState('');
    const [orderForm, setOrderForm] = useState(initialOrderForm);
    const [orderClientSearch, setOrderClientSearch] = useState('');
    const [editingClientId, setEditingClientId] = useState(null);
    const [isLoadingClients, setIsLoadingClients] = useState(false);
    const [isSubmittingClient, setIsSubmittingClient] = useState(false);
    const [isLoadingOrders, setIsLoadingOrders] = useState(false);
    const [isSubmittingOrder, setIsSubmittingOrder] = useState(false);
    const [isLoadingBills, setIsLoadingBills] = useState(false);
    const [isSubmittingBill, setIsSubmittingBill] = useState(false);
    const [isLoadingBillDetails, setIsLoadingBillDetails] = useState(false);
    const [clientMessage, setClientMessage] = useState('');
    const [clientError, setClientError] = useState('');
    const [, setOrderMessage] = useState('');
    const [orderError, setOrderError] = useState('');
    const [billMessage, setBillMessage] = useState('');
    const [billError, setBillError] = useState('');
    const [previewUrl, setPreviewUrl] = useState(null);
    const [uploadedUrl, setUploadedUrl] = useState(null);
    const [showOrderSuccessModal, setShowOrderSuccessModal] = useState(false);
    const [orderSuccessMessage, setOrderSuccessMessage] = useState('Order updated successfully');
    const [orderShareClientId, setOrderShareClientId] = useState('');
    const [orderShareOrder, setOrderShareOrder] = useState(null);
    const fileInputRef = useRef(null);

    const [isScanning, setIsScanning] = useState(false);
    const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp'];
    const ALLOWED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];


    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [editedOrder, setEditedOrder] = useState({});
    const [saving, setSaving] = useState(false);

    const [selectedOrders, setSelectedOrders] = useState([]);

    const handleRowClick = (order) => {
        setSelectedOrders((prev) => {
            const exists = prev.find(o => o.id === order.id);

            if (exists) {
                return prev.filter(o => o.id !== order.id); // unselect
            } else {
                return [...prev, order]; // select
            }
        });
    };


    const handlePrintSelected = () => {
        if (selectedOrders.length === 0) {
            alert("No orders selected");
            return;
        }

        const escapeHtml = (value) =>
            String(value ?? "-")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");

        const perPage = 6;
        const totalPages = Math.ceil(selectedOrders.length / perPage);
        const printWindow = window.open("", "_blank");

        if (!printWindow) {
            alert("Unable to open print preview. Please allow pop-ups and try again.");
            return;
        }

        const pagesHtml = Array.from({ length: totalPages }, (_, pageIndex) => {
            const start = pageIndex * perPage;
            const pageOrders = selectedOrders.slice(start, start + perPage);
            const cardsHtml = pageOrders
                .map((order) => {
                    const imageHtml = order.imagePath
                        ? `<img src="${escapeHtml(order.imagePath)}" alt="Order" class="main-image" />`
                        : `<div class="media-placeholder">No Image</div>`;

                    const qrHtml = order.qrCodePath
                        ? `<img src="${escapeHtml(order.qrCodePath)}" alt="QR Code" class="qr-image" />`
                        : `<div class="media-placeholder qr-placeholder">No QR</div>`;

                    return `
                        <article class="order-card">
                            <header class="order-head">
                                <div class="order-id">Order #${escapeHtml(order.id)}</div>
                                <div class="order-stage">${escapeHtml(order.currentStage || "Pending")}</div>
                            </header>

                            <div class="media-wrap">
                                <div class="image-box">${imageHtml}</div>
                                <div class="qr-box">${qrHtml}</div>
                            </div>

                            <div class="meta-grid">
                                <div class="meta-item">
                                    <div class="meta-label">Client</div>
                                    <div class="meta-value">${escapeHtml(order.clientName || "-")}</div>
                                </div>
                                <div class="meta-item">
                                    <div class="meta-label">Size</div>
                                    <div class="meta-value">${escapeHtml(order.height || 0)} x ${escapeHtml(order.width || 0)}</div>
                                </div>
                                <div class="meta-item">
                                    <div class="meta-label">Qty</div>
                                    <div class="meta-value">${escapeHtml(order.quantity || 0)}</div>
                                </div>
                                <div class="meta-item">
                                    <div class="meta-label">Sq Ft</div>
                                    <div class="meta-value">${Number(order.totalSquareFeet || 0).toFixed(2)}</div>
                                </div>
                            </div>

                            <div class="desc-block">
                                <div class="meta-label">Description</div>
                                <div class="desc-value">${escapeHtml(order.description || "-")}</div>
                            </div>
                        </article>
                    `;
                })
                .join("");

            const placeholders = Array.from({ length: Math.max(0, perPage - pageOrders.length) }, () => '<div class="order-card ghost"></div>').join("");

            return `
                <section class="print-page">
                    <div class="sheet-header">
                        <div class="sheet-title">Selected Orders</div>
                        <div class="sheet-meta">Page ${pageIndex + 1} of ${totalPages} | Total ${selectedOrders.length}</div>
                    </div>
                    <div class="cards-grid">
                        ${cardsHtml}
                        ${placeholders}
                    </div>
                </section>
            `;
        }).join("");

        const html = `
<!doctype html>
<html>
<head>
    <meta charset="utf-8" />
    <title>Print Orders</title>
    <style>
        @page { size: A4; margin: 8mm; }
        * { box-sizing: border-box; }
        body {
            margin: 0;
            font-family: "Segoe UI", Arial, sans-serif;
            color: #111827;
            background: #fff;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }

        .print-page {
            page-break-after: always;
        }

        .print-page:last-child {
            page-break-after: auto;
        }

        .sheet-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2.8mm;
            padding-bottom: 1.8mm;
            border-bottom: 1px solid #d1d5db;
        }

        .sheet-title {
            font-size: 14px;
            font-weight: 700;
            letter-spacing: 0.2px;
        }

        .sheet-meta {
            font-size: 9px;
            color: #6b7280;
        }

        .cards-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 2.6mm;
        }

        .order-card {
            border: 1px solid #cfd8e3;
            border-radius: 2.2mm;
            padding: 2.1mm;
            background: #fff;
            min-height: 83mm;
            break-inside: avoid;
            page-break-inside: avoid;
            display: flex;
            flex-direction: column;
            gap: 1.6mm;
        }

        .order-card.ghost {
            border-style: dashed;
            border-color: #e5e7eb;
            background: #fafafa;
        }

        .order-head {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            gap: 8px;
            border-bottom: 1px solid #e8edf3;
            padding-bottom: 1.2mm;
        }

        .order-id {
            font-size: 12px;
            font-weight: 700;
        }

        .order-stage {
            font-size: 8.5px;
            font-weight: 700;
            color: #475569;
            text-transform: uppercase;
            letter-spacing: 0.45px;
        }

        .media-wrap {
            display: grid;
            grid-template-columns: minmax(0, 1fr) 31mm;
            gap: 1.8mm;
            align-items: stretch;
        }

        .image-box,
        .qr-box {
            border: 1px solid #e5e7eb;
            border-radius: 1.8mm;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
        }

        .image-box {
            height: 42mm;
        }

        .qr-box {
            height: 31mm;
        }

        .main-image,
        .qr-image {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .media-placeholder {
            font-size: 8px;
            color: #9ca3af;
            text-transform: uppercase;
            letter-spacing: 0.6px;
        }

        .meta-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 1.1mm 2.2mm;
        }

        .meta-item {
            border-top: 1px solid #eef2f7;
            padding-top: 0.8mm;
        }

        .meta-label {
            font-size: 8.1px;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.45px;
            margin-bottom: 0.4mm;
        }

        .meta-value {
            font-size: 10px;
            font-weight: 600;
            color: #0f172a;
            line-height: 1.22;
            word-break: break-word;
        }

        .desc-block {
            border-top: 1px solid #eef2f7;
            padding-top: 0.9mm;
        }

        .desc-value {
            font-size: 9.6px;
            color: #1f2937;
            line-height: 1.3;
            word-break: break-word;
        }
    </style>
</head>
<body>
    ${pagesHtml}
</body>
</html>
        `;

        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();

        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        };
    };


    const [showAddOrderModal, setShowAddOrderModal] = useState(false);


    const getRequestHeaders = useCallback(() => {
        const headers = { 'Content-Type': 'application/json' };
        if (authToken) {
            headers.Authorization = `Bearer ${authToken}`;
        }
        return headers;
    }, [authToken]);

    const fetchClients = useCallback(async () => {
        setIsLoadingClients(true);
        setClientError('');

        try {
            const response = await fetch(API.CLIENTS_API_URL, {
                headers: getRequestHeaders()
            });

            // 🔴 Handle 403 globally here
            if (response.status === 403) {
                onLogout();
                return;
            }

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Unable to load clients');
            }

            setClients(data.clients || []);
            setClientMessage(data.message || 'Clients retrieved successfully');

        } catch (fetchError) {
            setClientError(fetchError.message || 'Unable to load clients');
        } finally {
            setIsLoadingClients(false);
        }
    }, [getRequestHeaders, onLogout]);

    const handleOrderSubmit = async (event) => {
        event.preventDefault();
        if (!uploadedUrl) {
            setOrderError('Please upload a valid image before adding the order.');
            return;
        }
        setIsSubmittingOrder(true);
        setOrderError('');
        setOrderMessage('');
        const payload = {
            ...orderForm,
            height: Number(orderForm.height),
            width: Number(orderForm.width),
            quantity: Number(orderForm.quantity),
            rate: Number(orderForm.rate),
            clientId: Number(orderForm.clientId),
            imagePath: uploadedUrl
        };

        try {
            const response = await fetch(API.ORDERS_API_URL, {
                method: 'POST',
                headers: getRequestHeaders(),
                body: JSON.stringify(payload),
            });
            console.log(response);
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Unable to save order');
            }

            const createdOrder = data?.order || {};
            const createdOrderId = createdOrder?.id || data?.id || '';
            const normalizedCreatedOrder = {
                id: createdOrderId || '',
                description: payload.description || '',
                height: payload.height,
                width: payload.width,
                quantity: payload.quantity,
                currentStage: createdOrder?.currentStage || 'Pending',
                mode: createdOrder?.mode || '',
                orderId: createdOrder.orderId,
            };

            setOrderMessage(data.message || 'Order added successfully');
            setOrderSuccessMessage('Order updated successfully');
            setOrderShareClientId(String(payload.clientId || ''));
            setOrderShareOrder(normalizedCreatedOrder);
            resetOrderForm();
            await fetchOrders();
            setShowAddOrderModal(false);
            setShowOrderSuccessModal(true);
        } catch (submitError) {
            setOrderError(submitError.message || 'Unable to save order');
        } finally {
            setIsSubmittingOrder(false);
        }
    };

    const closeOrderSuccessModal = () => {
        setShowOrderSuccessModal(false);
    };

    const handleShareOnWhatsApp = async (clientId, order) => {
        try {
            await shareOrderOnWhatsApp({
                clientId,
                order,
                getRequestHeaders,
            });
        } catch (error) {
            alert(error.message || 'Unable to open WhatsApp share');
        }
    };

    const handleOrderClientSearchChange = ({ target: { value } }) => {
        setOrderClientSearch(value);

        if (!value.trim()) {
            setOrderForm((current) => ({ ...current, clientId: '' }));
        }
    };

    const filteredClientsForOrderSearch = useMemo(() => {
        const searchValue = orderClientSearch.trim().toLowerCase();

        if (!searchValue) {
            return [];
        }

        return clients
            .filter((client) =>
                `${client.clientName || ''} ${client.phoneNumber || ''}`
                    .toLowerCase()
                    .includes(searchValue)
            )
            .slice(0, 6);
    }, [clients, orderClientSearch]);

    const handleSelectOrderClient = (client) => {
        setOrderClientSearch(client.clientName || '');
        setOrderForm((current) => ({
            ...current,
            clientId: String(client.id),
        }));
    };

    const resetOrderForm = () => {
        setOrderForm(initialOrderForm);
        setOrderClientSearch('');
        setPreviewUrl(null);
        setUploadedUrl(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // clears file input
        }
    }

    const handleDeleteOrder = async (orderId) => {
        // ask user to re-enter order id
        const input = prompt("Enter Order ID to confirm deletion:");

        // if cancelled
        if (input === null) return;

        // validate
        if (input.trim() !== String(orderId)) {
            alert("Wrong Order ID. Deletion cancelled.");
            return;
        }

        try {
            const res = await fetch(`${API.ORDERS_API_URL}/${orderId}`, {
                method: "DELETE",
                headers: getRequestHeaders(),
            });

            if (res.ok) {
                // remove from UI
                setOrders(prev => prev.filter(order => order.id !== orderId));
            } else {
                const data = await res.json();
                alert(data.error || "Failed to delete order");
            }

        } catch (err) {
            console.error(err);
            alert("Error deleting order");
        }
    };


    const handleEditOrder = (order) => {
        console.log(order)
        setSelectedOrder(order);

        // clone editable fields
        setEditedOrder({
            description: order.description || '',
            height: order.height || '',
            width: order.width || '',
            quantity: order.quantity || '',
            rate: order.rate || '',
            // amount optional (will be derived if backend expects rate)
            amount: order.amount || '',
            currentStage: order.currentStage || '',
            totalSquareFeet: order.totalSquareFeet || '',
            imagePath: order.imagePath || ''
        });

        setShowEditModal(true);
    };

    const handleStageChange = async (orderId, newStage) => {
        try {
            const currentOrder = orders.find((order) => order.id === orderId);
            let stageToSend = newStage;
            let mode = null;

            if (
                newStage === "Delivered via Porter" ||
                newStage === "Client Picked Up"
            ) {
                stageToSend = "Delivered";
                mode = newStage;
            }

            let url = `${API.ORDERS_API_URL}/${orderId}/stage?stage=${encodeURIComponent(stageToSend)}`;

            if (mode) {
                url += `&mode=${encodeURIComponent(mode)}`;
            }

            const response = await fetch(url, {
                method: "PUT",
                headers: getRequestHeaders(),
            });
            if (!response.ok) {
                throw new Error("Unable to update order stage");
            }

            // update UI locally
            setOrders(prev =>
                prev.map(order =>
                    order.id === orderId
                        ? {
                            ...order,
                            currentStage: newStage,        // keep UI as selected option
                            deleiverdThorugh: mode || order.deleiverdThorugh
                        }
                        : order
                )
            );

            if (currentOrder?.clientId) {
                setOrderShareClientId(String(currentOrder.clientId));
                setOrderShareOrder({
                    ...currentOrder,
                    currentStage: newStage,
                    mode: mode || currentOrder.mode || '',
                });
                setOrderSuccessMessage('Order updated successfully');
                setShowOrderSuccessModal(true);
            }

        } catch (error) {
            console.error("Failed to update stage", error);
        }
    };

    const fetchOrders = useCallback(async () => {
        setIsLoadingOrders(true);
        setOrderError('');
        try {
            const response = await fetch(API.ORDERS_API_URL, { headers: getRequestHeaders() });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Unable to load orders');
            }
            setOrders(data.orders || []);
            setOrderMessage(data.message || 'Orders retrieved successfully');
        } catch (fetchError) {
            setOrderError(fetchError.message || 'Unable to load orders');
        } finally {
            setIsLoadingOrders(false);
        }
    }, [getRequestHeaders]);

    const totalSquareFeet =
        (Number(orderForm.height || 0) * Number(orderForm.width || 0)) / 144;
    const estimatedAmount =
        totalSquareFeet * Number(orderForm.quantity || 0) * Number(orderForm.rate || 0);

    const handleOrderFormChange = ({ target: { name, value } }) => {
        setOrderForm((current) => ({ ...current, [name]: value }));
    };

    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files || []);
        if (files.length !== 1) {
            setOrderError('Please select exactly one image file.');
            setPreviewUrl(null);
            setUploadedUrl(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            return;
        }

        const file = files[0];
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
        const hasValidExtension = ALLOWED_IMAGE_EXTENSIONS.includes(fileExtension || '');
        const hasValidMimeType = file.type
            ? ALLOWED_IMAGE_MIME_TYPES.includes(file.type.toLowerCase())
            : true;

        if (!hasValidExtension || !hasValidMimeType) {
            setOrderError('Only image files with .jpg, .jpeg, .png or .webp are allowed.');
            setPreviewUrl(null);
            setUploadedUrl(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            return;
        }

        const pUrl = URL.createObjectURL(file);
        setPreviewUrl(pUrl);
        setUploadedUrl(null);
        setOrderError('');
        setOrderMessage('');
        setIsScanning(true);

        try {
            const formData = new FormData();
            formData.append("file", file);

            const res = await fetch(`${API.ORDERS_API_URL}/upload`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${authToken}`
                },
                body: formData
            });

            const rawResponse = await res.text();
            const uploadedImageUrl = rawResponse.trim().replace(/^"|"$/g, '');

            if (!res.ok || !uploadedImageUrl) {
                throw new Error('Image upload failed. Please try again.');
            }

            setUploadedUrl(uploadedImageUrl);
        } catch (error) {
            setOrderError(error.message || 'Image upload failed. Please try again.');
            setUploadedUrl(null);
        } finally {
            setIsScanning(false);
        }
    };


    useEffect(() => {
        fetchOrders();
        fetchClients();
    }, [fetchClients, fetchOrders]);




    const openAddOrderModal = async () => {
        setIsLoadingClients(true);
        setClientError('');

        try {
            await fetchClients(); // ✅ safe, memoized
            setShowAddOrderModal(true);
        } catch (err) {
            setClientError("Failed to load clients");
        } finally {
            setIsLoadingClients(false);
        }
    };

    const closeAddOrderModal = () => {
        setShowAddOrderModal(false);

        // cleanup (important)
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
    };

    return (
        <div className="modal-body px-3 px-md-4 py-3 py-md-4">
            <div className="row g-4">

                {/* LEFT: FORM */}


                {/* RIGHT: TABLE */}
                <div className="col-12">

                    <div className="d-flex justify-content-between align-items-center mb-3">

                        <div>
                            <h6 className="fw-semibold mb-0">Orders</h6>
                            <small className="text-muted">
                                {isLoadingOrders ? "Loading..." : `${orders.length} total`}
                            </small>
                        </div>

                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-sm btn-dark"
                                onClick={() => handlePrintSelected()}
                            >
                                Print Selected ({selectedOrders.length})
                            </button>
                            {/* 🔥 ADD ORDER BUTTON */}
                            <button
                                className="btn btn-sm btn-dark"
                                onClick={openAddOrderModal}
                                disabled={isLoadingClients}
                            >
                                {isLoadingClients ? "Loading..." : "+ Add Order"}
                            </button>

                            <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={fetchOrders}
                                disabled={isLoadingOrders}
                            >
                                Refresh
                            </button>
                        </div>

                    </div>

                    <div className="table-responsive">
                        <table className="table table-hover align-middle">

                            <thead className="table-light">
                                <tr>
                                    <th>ID</th>
                                    <th>Img</th>
                                    <th>QR</th>
                                    <th>Description</th>
                                    <th className="d-none d-md-table-cell">Client</th>
                                    <th className="d-none d-lg-table-cell">Size</th>
                                    <th>Qty</th>
                                    <th className="d-none d-lg-table-cell">Rate</th>
                                    <th>Square Foots</th>
                                    <th className="d-none d-lg-table-cell">Amount</th>
                                    <th>Status</th>
                                    <th>Billed</th>
                                    <th>Oprations</th>
                                    <th>Share</th>
                                </tr>
                            </thead>

                            <tbody>
                                {!isLoadingOrders && orders.length === 0 && (
                                    <tr>
                                        <td
                                            colSpan={
                                                document.querySelectorAll("thead th").length || 1
                                            }
                                            className="text-center text-muted py-4"
                                        >
                                            No orders found
                                        </td>
                                    </tr>
                                )}

                                {orders.map((order) => (
                                    <tr
                                        key={order.id}
                                        onClick={() => handleRowClick(order)}
                                        className={selectedOrders.some((o) => o.id === order.id) ? "table-primary" : ""}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <td onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/orders/${order.id}`);
                                        }} style={{ cursor: "pointer" }}>
                                            {order.id}
                                        </td>
                                        <td>
                                            {order.imagePath ? (
                                                <img
                                                    src={order.imagePath}
                                                    alt=""
                                                    style={{ width: 50, height: 50, objectFit: "cover" }}
                                                    className="rounded"
                                                />
                                            ) : "—"}
                                        </td>

                                        <td>
                                            {order.qrCodePath ? (
                                                <img
                                                    src={order.qrCodePath}
                                                    alt=""
                                                    style={{ width: 50, height: 50, objectFit: "cover" }}
                                                    className="rounded"
                                                />
                                            ) : "—"}
                                        </td>

                                        <td>
                                            <strong>{order.description}</strong>
                                            <div className="small text-muted">
                                                {Number(order.totalSquareFeet || 0).toFixed(2)} sq ft
                                            </div>
                                        </td>

                                        <td className="d-none d-md-table-cell">
                                            {order.clientName}
                                        </td>

                                        <td className="d-none d-lg-table-cell">
                                            {order.height} x {order.width}
                                        </td>

                                        <td>{order.quantity}</td>

                                        <td className="d-none d-lg-table-cell">
                                            {Number(order.rate || 0).toFixed(2)}
                                        </td>
                                        <td className="d-none d-lg-table-cell">
                                            {Number(order.totalSquareFeet || 0).toFixed(2)}
                                        </td>

                                        <td className="d-none d-lg-table-cell">
                                            {Number(order.amount || 0).toFixed(2)}
                                        </td>

                                        <td style={{ minWidth: "140px" }}>
                                            {order.billed ? (
                                                <span className="badge bg-secondary">Locked</span>
                                            ) : (
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={
                                                        order.currentStage === "Delivered"
                                                            ? order.mode || "Delivered"
                                                            : order.currentStage || ""
                                                    }
                                                    onChange={(e) =>
                                                        handleStageChange(order.id, e.target.value)
                                                    }
                                                >
                                                    <option value="">Select Status</option>

                                                    <option>Pending</option>
                                                    <option>Processing</option>
                                                    <option>Glass Cutting With Frosted</option>
                                                    <option>Glass Cutting</option>
                                                    <option>Polishing</option>
                                                    <option>Dispatched for Coloring</option>
                                                    <option>Returned from Coloring</option>
                                                    <option>Completed</option>

                                                    {/* Delivered options */}
                                                    <option>Delivered via Porter</option>
                                                    <option>Client Picked Up</option>
                                                </select>
                                            )}
                                        </td>

                                        <td>
                                            {order.billed ? (
                                                <span className="badge bg-warning text-dark">
                                                    Billed
                                                </span>
                                            ) : (
                                                <span className="badge bg-light text-muted">
                                                    No
                                                </span>
                                            )}
                                        </td>
                                        <td className="text-end">
                                            <div className="btn-group btn-group-sm">
                                                <button
                                                    className="btn btn-outline-primary"
                                                    onClick={() => handleEditOrder(order)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className="btn btn-outline-danger"
                                                    onClick={() => handleDeleteOrder(order.id)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <ShareOnWhatsAppIconButton
                                                label={`Share order ${order.id} on WhatsApp`}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleShareOnWhatsApp(order.clientId, order);
                                                }}
                                            />
                                        </td>

                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>

                </div>
            </div>

            {showAddOrderModal && (
                <div
                    className="modal fade show d-block"
                    style={{ background: "rgba(0,0,0,0.5)", zIndex: 2000 }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
                        <div className="modal-content rounded-4">

                            {/* HEADER */}
                            <div className="modal-header">
                                <h5 className="modal-title">Add Order</h5>
                                <button
                                    className="btn-close"
                                    onClick={closeAddOrderModal}
                                ></button>
                            </div>

                            {/* BODY */}
                            <div className="modal-body">

                                {orderError && <div className="alert alert-danger">{orderError}</div>}

                                <form onSubmit={handleOrderSubmit}>

                                    {/* Client Search */}
                                    <div className="mb-3">
                                        <label className="form-label small">Client</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search client"
                                            value={orderClientSearch}
                                            onChange={handleOrderClientSearchChange}
                                        />

                                        {orderClientSearch.trim() && (
                                            <div
                                                className="mt-2"
                                                style={
                                                    filteredClientsForOrderSearch.length > 3
                                                        ? { maxHeight: '170px', overflowY: 'auto', paddingRight: '4px' }
                                                        : undefined
                                                }
                                            >
                                                {filteredClientsForOrderSearch.map((client) => (
                                                    <button
                                                        key={client.id}
                                                        type="button"
                                                        className={`w-100 text-start btn btn-sm ${String(orderForm.clientId) === String(client.id)
                                                            ? "btn-primary"
                                                            : "btn-outline-secondary"
                                                            } mb-1`}
                                                        onClick={() => handleSelectOrderClient(client)}
                                                    >
                                                        {client.clientName}
                                                        <br />
                                                        <small>{client.phoneNumber}</small>
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    {/* File */}
                                    <div className="mb-3">
                                        <label className="form-label small">Upload File</label>
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            className="form-control"
                                            onChange={handleFileChange}
                                            accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
                                            multiple={false}
                                            required
                                        />

                                        {previewUrl && (
                                            <img
                                                src={previewUrl}
                                                alt="preview"
                                                className="img-fluid rounded border mt-2"
                                                style={{ maxHeight: "150px" }}
                                            />
                                        )}
                                    </div>

                                    {/* Description */}
                                    <div className="mb-3">
                                        <label className="form-label small">Description</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="description"
                                            value={orderForm.description}
                                            onChange={handleOrderFormChange}
                                            required
                                        />
                                    </div>

                                    {/* Dimensions */}
                                    <div className="row g-2">
                                        <div className="col-6">
                                            <input
                                                type="number"
                                                placeholder="Height"
                                                className="form-control"
                                                name="height"
                                                value={orderForm.height}
                                                onChange={handleOrderFormChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-6">
                                            <input
                                                type="number"
                                                placeholder="Width"
                                                className="form-control"
                                                name="width"
                                                value={orderForm.width}
                                                onChange={handleOrderFormChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Qty + Rate */}
                                    <div className="row g-2 mt-2">
                                        <div className="col-6">
                                            <input
                                                type="number"
                                                placeholder="Qty"
                                                className="form-control"
                                                name="quantity"
                                                value={orderForm.quantity}
                                                onChange={handleOrderFormChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-6">
                                            <input
                                                type="number"
                                                placeholder="Rate"
                                                className="form-control"
                                                name="rate"
                                                value={orderForm.rate}
                                                onChange={handleOrderFormChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Summary */}
                                    <div className="bg-light border rounded p-2 mt-3 small">
                                        <div>Total sq ft: {totalSquareFeet.toFixed(2)}</div>
                                        <div>Amount: {estimatedAmount.toFixed(2)}</div>
                                    </div>

                                    {/* FOOTER */}
                                    <div className="d-flex justify-content-end gap-2 mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={closeAddOrderModal}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="btn btn-dark"
                                            disabled={isSubmittingOrder || isScanning}
                                        >
                                            {isScanning ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Uploading
                                                </>
                                            ) : isSubmittingOrder ? "Saving..." : "Add Order"}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <OrderShareSuccessModal
                show={showOrderSuccessModal}
                message={orderSuccessMessage}
                onClose={closeOrderSuccessModal}
                onShare={() => handleShareOnWhatsApp(orderShareClientId, orderShareOrder)}
            />
        </div>
    );
}

export default Orders;

